import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/main.module.scss';

import GlobalContext from '../_contexts/GlobalContext';
import Header from './Header';
import Footer from './footerComponent';
import { Popup, Stack, Image, Label, DefaultButton, PrimaryButton } from '@fluentui/react';
import { popupStyles } from '../constants/constants';
import { Site } from '../constants/types';
import RequestForm from './requestForm';
import InfoForm from './infoForm';
import ShowToastComponent from './showToastComponent';


export interface ImainComponentProps {

}

const MainComponent: React.FunctionComponent<ImainComponentProps> = (props: ImainComponentProps) => {
    const [init, setinit] = useState<boolean>(true);
    const [errormessage, seterrormessage] = useState<string>();
    const [message, setmessage] = useState<string>();

    const { DebugEnabled, UNDERCONSTRUCTION } = useContext(GlobalContext);
    const promosites: Site[] = [{ id: 0, name: "pokemon.collectietekoop.nl", url: "https://pokemon.collectietekoop.nl", logo: window.location.origin + "/assets/promosites/pokemoncollectie.webp" },
    { id: 1, name: "retrogames.collectietekoop.nl", url: "https://retrogames.collectietekoop.nl", logo: window.location.origin + "/assets/promosites/retrocollectie.webp" }];
    const pageWidth = window.innerWidth - 25 > 1232 ? 1232 : window.innerWidth;

    const apiUrl = window.location.origin + "/Backend";

    const contactRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        console.warn = console.error = () => { }; //disable warnings
        setinit(false);
    }, []);

    //TODO: documentatie voor klanten en menu

    return (
        init === true ? <div>Loading</div> :
            <Stack horizontalAlign='center'>
                {UNDERCONSTRUCTION && !DebugEnabled && <Popup
                    hidden={false}
                    role="dialog"
                    aria-modal="true"
                    className={popupStyles.root}
                >
                    <div role="document" className={popupStyles.content}>
                        <Image  className={styles.popupImage}
                                style={{maxHeight: window.innerHeight - ((window.innerHeight/100) * 25), height: window.innerHeight - ((window.innerHeight/100) * 25)}}
                                src={`${window.location.origin}/assets/underconstruction.png`}
                                alt=""/>
                    </div>
                </Popup>}
                <ShowToastComponent message={errormessage ? errormessage : message}
                            isError={errormessage ? true : false}
                            timeout={2000} callback={() => { setmessage(undefined); seterrormessage(undefined); }} />
                <Stack className={styles.firstSection}>
                    <Header />
                    <Stack horizontalAlign='center' style={{ maxWidth: pageWidth < 960 ? 375 : "100%" }}>
                        <Stack>
                            <Stack className={styles.mainSection} horizontalAlign='center'>
                                <div >
                                    <h1>Goedkoop je collectie verkopen</h1>
                                </div>

                                <div className={styles.contactButton} onClick={() => { window.scrollTo(contactRef.current.offsetLeft,contactRef.current.offsetTop); }}>
                                    <span>Contact</span>
                                </div>
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack className={styles.mainSection}>
                    <Stack horizontalAlign='center' style={{ maxWidth: pageWidth < 960 ? 375 : "100%" }}>
                        <Stack style={{ maxWidth: pageWidth < 960 ? 375 : 960 }}>
                            <Stack horizontal horizontalAlign='start' style={{width:"100%"}} verticalAlign='center'>
                                    <img src={window.location.origin + "/assets/fast.png"} style={{ maxWidth: 370, maxHeight: 100, margin: 5, borderRadius: 50, border: "1px solid rgb(0, 120, 212)" }} />
                                    <ul>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Geen ingewikkelde configuratie, begin met verkopen binnen 1 dag</li>
                                    </ul>
                                </Stack>
                                <Stack horizontal horizontalAlign='start' style={{width:"100%"}} verticalAlign='center'>
                                    <img src={window.location.origin + "/assets/contact.png"} style={{ maxWidth: 370, maxHeight: 100, margin: 5, borderRadius: 5 }} />
                                    <ul style={{}}>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Beheer uw eigen zendingen.</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Beheer uw eigen klanten contact.</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Beheer uw eigen inventaris.</li>
                                    </ul>
                                </Stack>
                                <Stack horizontal horizontalAlign='start' style={{width:"100%"}} verticalAlign='center'>
                                    <img src={window.location.origin + "/assets/finance.png"} style={{ maxWidth: 370, maxHeight: 100, margin: 5, borderRadius: 5 }} />
                                    <ul>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Lage commisie van 3.5%.</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Opzeggen mogelijk per maand.</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Beheer uw eigen Mollie account of laat het over aan ons voor slechts 0.5% commisie.</li>
                                    </ul>
                                </Stack>
                                <Stack horizontal horizontalAlign='start' style={{width:"100%"}} verticalAlign='center'>
                                    <img src={window.location.origin + "/assets/config.png"} style={{ maxWidth: 370, maxHeight: 100, margin: 5, borderRadius: 5 }} />                                    
                                    <ul>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Bemiddeling in overdracht bezette gewenste naam. [naam].collectietekoop.nl</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Doorsturen naar een andere site mogelijk. Vraag naar een offerte.</li>
                                        <li style={{ fontSize: pageWidth < 960 ? "small" : "normal", maxWidth: "100%" }}>Eigen domein doorsturen naar uw collectietekoop site is mogelijk. Eénmalige configuratie kosten €50,-. Assistentie bij DNS configuratie beschikbaar.</li>
                                    </ul>
                                </Stack>
                            <Stack className={styles.mainSection} horizontalAlign='center'>
                                <Stack horizontal={window.innerWidth > 600 ? true : false} verticalAlign='center' horizontalAlign='start' style={{width:"100%",padding:10}}>
                                    <Stack style={{ width: "100%", color:"rgb(63, 97, 140)" }}>
                                        <h2>Verkoper die je voor ging</h2>
                                        <span>Grote collectie van orginele, mint conditie Pokémon kaarten. De collectie wordt continu aangevuld met nieuwe kaarten.</span>
                                    </Stack>
                                    <a href={promosites[0].url} target="_blank" style={{ width: "100%",position: "relative" }}>
                                        <img src={promosites[0].logo} style={{ maxWidth: "100%", margin: 5, borderRadius: 5 }} />
                                    </a>
                                </Stack>
                                <Stack horizontal={window.innerWidth > 600 ? true : false} verticalAlign='center' horizontalAlign='end' style={{width:"100%",padding:10}}>
                                    <Stack style={{ width: "100%", color:"rgb(63, 97, 140)" }}>
                                        <h2>Verkoper die je voor ging</h2>
                                        <span>Mooie collectie van retro games en consoles, van Nintendo, Sony Playstation en Microsoft XBOX.</span>
                                    </Stack>
                                    <a href={promosites[1].url} target="_blank" style={{ width: "100%", position: "relative" }}>
                                        <img src={promosites[1].logo} style={{ maxWidth: "100%", margin: 5, borderRadius: 5 }} />
                                    </a>
                                </Stack>
                                <div style={{ alignContent: "center" }}>
                                    {promosites.map(carouselItem => {
                                        return 
                                    })}
                                </div>
                            </Stack>
                            <div style={{ alignContent: "center", display: pageWidth < 960 ? "block" : "flex", maxWidth: "100%", width: "100%" }}>
                                <div ref={contactRef} style={{ width: pageWidth < 960 ? 370 : "50%", position: "relative" }}>
                                    <InfoForm apiUrl={apiUrl} setmessage={setmessage} seterror={seterrormessage} />
                                </div>
                                <div style={{ width: pageWidth < 960 ? 370 : "50%", position: "relative" }}>
                                    <RequestForm apiUrl={apiUrl} setmessage={setmessage} seterror={seterrormessage} />
                                </div>
                            </div>
                            <Footer />
                        </Stack>
                    </Stack>
                </Stack>

            </Stack>
    );
}

export default MainComponent;